import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="px-6 md:px-12 lg:px-24 py-32 md:py-48 bg-[#0A0A0A] text-[#F4F4F0]" data-testid="testimonials-section">
      <p className="font-body text-xs uppercase tracking-[0.25em] text-neutral-400 mb-12">(04) — Words</p>
      <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-16 md:mb-24 max-w-4xl">
        Said about the <span className="font-serif-italic font-normal text-[#FF3E00]">work</span>.
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        {items.map((t, i) => (
          <motion.figure
            key={t.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="border-t border-neutral-700 pt-8"
            data-testid={`testimonial-${i}`}
          >
            <blockquote className="font-display font-light text-2xl md:text-3xl leading-tight tracking-tight">
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-8 font-body text-sm">
              <div className="font-semibold">{t.author}</div>
              {t.role && <div className="text-neutral-400">{t.role}</div>}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
